import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TwcModule } from '@topcon/twc-angular';

import { LayoutViewerComponent } from './layout-viewer.component';

@NgModule({
    declarations: [LayoutViewerComponent],
    imports: [CommonModule, TwcModule, DragDropModule],
    exports: [LayoutViewerComponent],
})
export class LayoutViewerModule {}
